(() => {
  const loader = document.currentScript;
  const source = loader?.dataset.predictiveSearchSrc;
  const styleSource = loader?.dataset.predictiveSearchStyle;
  const header = loader?.closest('store-header') || document.querySelector('store-header');
  if (!source || !header) return;

  let requested = false;
  const load = () => {
    if (requested || customElements.get('predictive-search')) return;
    requested = true;

    if (styleSource && !document.querySelector(`link[href="${styleSource}"]`)) {
      const stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = styleSource;
      document.head.append(stylesheet);
    }

    const script = document.createElement('script');
    script.src = source;
    script.defer = true;
    document.head.append(script);
  };

  ['pointerover', 'pointerdown', 'focusin'].forEach((eventName) => {
    header.addEventListener(eventName, load, { once: true, passive: true });
  });

  if ('requestIdleCallback' in window) {
    requestIdleCallback(load, { timeout: 2500 });
  } else {
    window.setTimeout(load, 1800);
  }
})();
